import React, { Component } from 'react';
import CustomModal from '../common/CustomModal';
import { Modal } from 'react-bootstrap';
import Gmaps from '../common/Gmaps';
import { imageBasePath } from '../../constants/staticData';

export default class SelectAddressModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLocation: props.selectedLocation,
      setCenter: true
    }
  }

  onSearchBoxMounted(searchBox) {
    this._searchBox = searchBox;
  }

  onPlacesChanged() {
    const places = this._searchBox.getPlaces();
    this.setState({ selectedLocation: {
      lat: places[0].geometry.location.lat(),
      lng: places[0].geometry.location.lng(),
      address: places[0].formatted_address
    }, setCenter: true });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedLocation) {
      this.setState({'selectedLocation': nextProps.selectedLocation});
    }
  }

  selectedLocationCallBack(){
    if (this.state.selectedLocation && !this.state.selectedLocation.address) {
      let geocoder = new google.maps.Geocoder;
      const that = this;
      geocoder.geocode({ 'location': { lat: this.state.selectedLocation.lat, lng: this.state.selectedLocation.lng } }, function (results, status) {
        if (status === 'OK' && results[0]) {
          that.setState({
            'selectedLocation': {
              'lat': results[0].geometry.location.lat(),
              'lng': results[0].geometry.location.lng(),
              'address': results[0].formatted_address
            }
          })
          that.props.selectedLocationCallBack({
            'lat': results[0].geometry.location.lat(),
            'lng': results[0].geometry.location.lng(),
            'address': results[0].formatted_address
          });
        }
      });
    } else {
      this.props.selectedLocationCallBack(this.state.selectedLocation);
    }
  }

  markerDrag(map) {
    let geocoder = new google.maps.Geocoder;
    const that = this;
    geocoder.geocode({ 'location': { lat: map.latLng.lat(), lng: map.latLng.lng() } }, function (results, status) {
      if (status === 'OK' && results[0]) {
        that.setState({
          'selectedLocation': {
            'lat': results[0].geometry.location.lat(),
            'lng': results[0].geometry.location.lng(),
            'address': results[0].formatted_address
          }
        })
      }
    })
  }

  pickCurrentLocation() {
    if (navigator.geolocation) {
      const that = this;
      navigator.geolocation.getCurrentPosition(function(position){
        that.setState({'selectedLocation': {'lat': position.coords.latitude, 'lng': position.coords.longitude}});
      }, function(error) {
        switch(error.code) {
          case error.PERMISSION_DENIED:
            that.props.actions.showToastMessage('Please grant permission to use location service', 'error');
            break;
          case error.POSITION_UNAVAILABLE:
            that.props.actions.showToastMessage('Location information is unavailable.', 'error');
            break;
          case error.TIMEOUT:
            that.props.actions.showToastMessage('The request to get user location timed out.', 'error');
            break;
          case error.UNKNOWN_ERROR:
            that.props.actions.showToastMessage('An unknown error occurred.', 'error');
            break;
      }
      });
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  render() {
    const { hideModalCallback, selectedLocationCallBack } = this.props;
    return (
      <CustomModal hideModal={hideModalCallback}
        className="map-modal" showModal={this.props.showModal}
        footer={true} title="Mark your location" saveText="Select Location"
        submitCallBack={this.selectedLocationCallBack.bind(this)}>
        <Modal.Body>
          <div className="gmaps">
            <Gmaps
              /* mapDrag={() => { this.setState({ setCenter: false }); }} */
              setCenter={this.state.setCenter}
              center={this.state.selectedLocation}
              zoom={15}
              containerElement={<div style={{ height: "auto", width: 100 + '%' }} />}
              mapElement={<div className="map-element" style={{ height: 520 + 'px', width: 100 + '%' }} />}
              marker={{ "position": this.state.selectedLocation }}
              pinImage={`${imageBasePath}/drag-loc.png`}
              markerDrag={this.markerDrag.bind(this)}
              onSearchBoxMounted={this.onSearchBoxMounted.bind(this)}
              onPlacesChanged={this.onPlacesChanged.bind(this)}
            />
            <span onClick={this.pickCurrentLocation.bind(this)} className="current-position search-bar"><i className="mdi mdi-crosshairs-gps"></i></span>
          </div>
        </Modal.Body>
      </CustomModal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfileCreation/SelectAddressModal.jsx